import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class StockSearch extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        searchTxt: '代码/拼音/名称',
    };

    handleChange = e => {
        const val = e.currentTarget.value;

        this.setState({ searchTxt: val });
    };

    handleFocus = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '代码/拼音/名称' ? '' : val,
            isShow: true,
        });
    };

    handleBlur = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '' ? '代码/拼音/名称' : val,
            isShow: false,
        });
    };

    render() {
        const { searchTxt } = this.state;
        const {
            content: { searchUrl, url, title },
        } = this.props;

        return (
            <div className={styles.stock_search}>
                <form method="get" action={searchUrl} target="_blank" rel={rel}>
                    <input
                        className={styles.text}
                        type="text"
                        name="keyword"
                        value={searchTxt}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                    <input className={styles.btn} type="submit" value="搜索" />
                    <a href={url} target="_blank" rel={rel}>
                        {title}
                    </a>
                </form>
            </div>
        );
    }
}

export default errorBoundary(StockSearch);
